<template>
  <div class="container">
    <div class="wrap box-shadow">
      <div class="row align-items-center img-panel">
                <div class="col text-center my-3">
                    <h1>{{ $t("home.welcome") }}</h1>
                </div>
            </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Home'
}
</script>

<style lang="scss" scoped>
.img-panel {
  min-height: 400px;
}
</style>



